import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  StateService,
  RouterService,
  ToolService,
  ConstructionDayReportFormComponent,
  ConstructionDayReportDetailComponent,
} from 'projects/shared/src/public-api';
import { ModalController, Platform } from '@ionic/angular';

@Component({
  selector: 'app-construction-day-report-overview',
  templateUrl: './construction-day-report-overview.component.html',
  styleUrls: ['./construction-day-report-overview.component.scss'],
  standalone: false,
})
export class ConstructionDayReportOverviewComponent implements OnInit {
  constructor(
    public state: StateService,
    public routerService: RouterService,
    public toolService: ToolService,
    public modalCtrl: ModalController,
    public platform: Platform
  ) {}

  ngOnInit() {}

  handleRefresh(event: any) {
    this.state.loadConstructionDayReports().subscribe((x) => {
      event.target.complete();
    });
  }

  async openConstructionDayReportFormModal(id: string) {
    const modal = await this.modalCtrl.create({
      component: ConstructionDayReportFormComponent,
      componentProps: {
        reportId: id,
      },
      cssClass: this.state.isBigScreen ? 'custom-desktop-modal' : '',
    });
    modal.present();
    const { data, role } = await modal.onWillDismiss();
    if (role === 'confirm' && id != null)
      this.openConstructionDayReportDetailModal(id);
  }

  async openConstructionDayReportDetailModal(id: string) {
    const modal = await this.modalCtrl.create({
      component: ConstructionDayReportDetailComponent,
      componentProps: {
        paramId: id,
      },
      cssClass: this.state.isBigScreen ? 'custom-desktop-modal' : '',
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      if (data == 'edit') {
        this.openConstructionDayReportFormModal(id);
      } else if (data == 'view') {
        await this.state.openFile(id, 'construction-day-report');
      }
    }
  }
}
